import { DataSourceTypeCode } from '../../Codes';
import { ProductTypes } from '../Models/Constants';

type AppRoute<TRoutePathArgs, TRouteQueryArgs = unknown> = (args0?: TRoutePathArgs, args1?: TRouteQueryArgs) => string;

/* App Routes the user can navigate to */
export class AppRoutes {
    static CustomisePage: AppRoute<{ windowCode: string; reportId: string; currentStage: number; pageId: string }> = ({
        windowCode,
        reportId,
        currentStage,
        pageId,
    }) => `/Report/build/${windowCode}?reportId=${reportId}&step=${currentStage}#step${currentStage}/${pageId}`;
    static FormulaGallery: AppRoute<{ windowCode: string; reportMode: string }> = ({ windowCode, reportMode }) =>
        `/OrganisationSettings/${windowCode}?reportMode=${reportMode}#formula-gallery`;

    static PracticeSettingsIntegrations = '/PracticeSettings#integrations';

    /* Transfrom In Action */
    static TransformInAction = 'https://transform.spotlightreporting.com/';

    /* Member */
    static MFASettings = '/Member/MFASettings';
    static ChangePassword = '/Member/ChangePassword';
    static SignOut = '/Member/Signout';

    static LandingPage = (productType: ProductTypes): string => {
        const productToLandingPage = {
            [ProductTypes.Reporting]: this.ReportingLandingPage,
            [ProductTypes.Dashboard]: this.DashboardsLandingPage,
            [ProductTypes.Forecasting]: this.ForecastingLandingPage,
            [ProductTypes.Multi]: this.MultiLandingPage,
            [ProductTypes.Sustain]: this.SustainLandingPage,
        };

        return productToLandingPage[productType];
    };

    /* Reporting */
    static ReportingLandingPage = '/Reporting/Organisations';

    /* Dashboards */
    static DashboardsLandingPage = '/Dashboard/Organisations';

    /* Multi */
    static MultiLandingPage = '/Multi/Organisations';

    /* Forecasting */
    static ForecastingLandingPage = '/Forecasting/Organisations';
    static AddDataSource: AppRoute<{ organisationId: string }> = ({ organisationId }) =>
        `/Forecasting/${organisationId}/AddDataSource`;
    static TaskManager: AppRoute<{ organisationId: string }> = ({ organisationId }) =>
        `/Forecasting/${organisationId}/TaskManager`;
    static TaskWizard: AppRoute<{ organisationId: string; isNewOrganisation: boolean }> = ({
        organisationId,
        isNewOrganisation,
    }) => `/Forecasting/${organisationId}/TaskManager/TaskWizard?isNewOrganisation=${isNewOrganisation}`;
    static ManageGroup: AppRoute<{ organisationId: string }> = ({ organisationId }) =>
        `/Forecasting/${organisationId}/ManageGroup`;
    static CreateBudget: AppRoute<{ windowCode: string; reportId: string }> = ({ windowCode, reportId }) =>
        `/Report/Build2/${windowCode}?reportId=${reportId}#BUDGETCUSTOMISE`;
    static CreateForecast: AppRoute<{ windowCode: string; reportId: string }> = ({ windowCode, reportId }) =>
        `/Report/Build2/${windowCode}?reportId=${reportId}#FORECASTCUSTOMISE`;
    static CustomiseBudget: AppRoute<{ windowCode: string; reportId: string; taskId: string }> = ({
        windowCode,
        reportId,
        taskId,
    }) => `/Report/Build2/${windowCode}?reportId=${reportId}#BUDGETCUSTOMISE/${taskId}`;
    static CustomiseForecast: AppRoute<{ windowCode: string; reportId: string; taskId: string }> = ({
        windowCode,
        reportId,
        taskId,
    }) => `/Report/Build2/${windowCode}?reportId=${reportId}#FORECASTCUSTOMISE/${taskId}`;
    static CustomiseDrivers: AppRoute<{ windowCode: string; reportId: string; dataSourceId: string }> = ({
        windowCode,
        reportId,
        dataSourceId,
    }) => `/Report/Build2/${windowCode}?reportId=${reportId}#DRIVERSCUSTOMISE/${dataSourceId}`;
    static CustomiseMeasures: AppRoute<{ windowCode: string; reportId: string; dataSourceId: string }> = ({
        windowCode,
        reportId,
        dataSourceId,
    }) => `/Report/Build2/${windowCode}?reportId=${reportId}#MEASURESCUSTOMISE/${dataSourceId}`;
    static CustomiseForecastPage: AppRoute<{ windowCode: string; reportId: string; pageId: string }> = ({
        windowCode,
        reportId,
        pageId,
    }) => `/Report/build2/${windowCode}?reportId=${reportId}#CUSTOMISELAYOUT/${pageId}`;

    static ExportXeroCSV: AppRoute<{ windowCode: string; reportId: string; dataSourceId: string }> = ({
        windowCode,
        reportId,
        dataSourceId,
    }) => `/reportexport/xerocsv/${windowCode}?reportId=${reportId}&dataSourceId=${dataSourceId}`;

    static ExportMyobCSV: AppRoute<{ windowCode: string; reportId: string; dataSourceId: string }> = ({
        windowCode,
        reportId,
        dataSourceId,
    }) => `/reportexport/myobcsv/${windowCode}?reportId=${reportId}&dataSourceId=${dataSourceId}`;

    /* Sustain */
    static SustainLandingPage = '/Sustain/Organisations';
    static SustainSelectTemplate: AppRoute<{ reportId: string }> = ({ reportId }) =>
        `/Sustain/Report/${reportId}/SelectTemplate`;
    static SustainAddData: AppRoute<{ reportId: string }> = ({ reportId }) => `/Sustain/Report/${reportId}/AddData`;
    static SustainDataSources: AppRoute<{ reportId: string }> = ({ reportId }) =>
        `/Sustain/Report/${reportId}/DataSources`;
    static SustainBuildReport: AppRoute<{ reportId: string }> = ({ reportId }) =>
        `/Sustain/ReportWizard/?reportId=${reportId}#step3`;
    static SustainPreviewAndShare: AppRoute<{ reportId: string }> = ({ reportId }) =>
        `/Sustain/Report/${reportId}/PreviewAndShare`;
    static SustainCustomisePage: AppRoute<{ reportId: string; currentStage: number; pageId: string }> = ({
        reportId,
        currentStage,
        pageId,
    }) => `/Sustain/ReportWizard/?reportId=${reportId}#step${currentStage}/${pageId}`;

    /* Help Centre */
    static DesktopConnectorHelp: AppRoute<{ dataSourceTypeCode: DataSourceTypeCode }> = ({ dataSourceTypeCode }) => {
        const baseUrl = 'https://help.spotlightreporting.com/reporting';
        const paths = {
            [DataSourceTypeCode.MyobAccountRightDesktop]: 'myob-accountright-desktop',
            [DataSourceTypeCode.QuickBooksDesktop]: 'quickbooks-desktop',
            [DataSourceTypeCode.Sage50Desktop]: 'sage-50-accounts',
        };

        return `${baseUrl}/${paths[dataSourceTypeCode]}`;
    };
}
